import React from "react";
import { Button, Space, version as antdVersion } from "antd";
export default (function (_ref) {
  var children = _ref.children,
    settings = _ref.config.settings;
  var renderSize = settings.renderSize;
  var antdMajorVersion = parseInt(antdVersion.split(".")[0]);
  if (antdMajorVersion >= 5) {
    return /*#__PURE__*/React.createElement(Space.Compact, {
      size: renderSize
    }, children);
  } else {
    var ButtonGroup = Button.Group;
    return /*#__PURE__*/React.createElement(ButtonGroup, {
      size: renderSize
    }, children);
  }
});